import { css } from "./common";
export const debugCss = {
    border: css `
    border: solid 1px black;
  `,
    outline: css `
    outline: solid 1px black;
  `,
    borderWhite: css `
    border: solid 1px white;
  `,
    borderRed: css `
    border: solid 1px red;
  `,
    bgRed: css `
    background: red;
  `,
    bgBlue: css `
    background: blue;
  `,
    opacity5: css `
    opacity: 0.5;
  `,
};
//# sourceMappingURL=debugCss.js.map